var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.118,
    height: 13.461,
    viewBox: "0 0 21.118 13.461"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ICN_Vizualizeaza calcul_Enabled",
    transform: "translate(.309 -2.009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.341 8.529s8.813-13.126 19.818 0c-10.129 14.057-19.818 0-19.818 0z",
    "data-name": "Path 107",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0091da",
    strokeWidth: 1.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 155",
    transform: "translate(6.45 4.58)",
    fill: "#0091da",
    stroke: "#0091da",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.129,
    cy: 4.129,
    r: 4.129,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.129,
    cy: 4.129,
    r: 3.479,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    "data-name": "Ellipse 156",
    transform: "translate(9.579 5.613)",
    fill: "#fff"
  }))));
}

export default SvgKpmgView;